import { Input } from "@progress/kendo-react-inputs";

export const FontSizeProperty = {
  propertyName: "fontSize",
  propertyDisplay: "Font Size",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        disabled={currentPropertyValues?.IsTab}
        type={"number"}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.IsTab ? "" : (currentPropertyValues?.[this.propertyName] ?? "")}
      />
    );
  },
};
